module.exports = __webpack_public_path__ + "img/photo-restaurant-partner.b57de5fe.png";